/**
 * Offline copy and detection shared by every surface that reads or writes over
 * the network (#18890). `navigator.onLine === false` is the only reliable signal:
 * `true` can still mean a captive portal, so only "definitely offline" swaps the
 * copy and anything else keeps the surface's own error text.
 */

export const OFFLINE_WRITE_MESSAGE = "You're offline. Reconnect and try again.";
export const OFFLINE_READ_MESSAGE = "You're offline. This will load when you reconnect.";

export function isBrowserOffline(): boolean {
  return typeof navigator !== 'undefined' && navigator.onLine === false;
}

/** The plain offline message when the browser is offline, otherwise `message`. */
export function offlineAwareMessage(message: string, offlineMessage = OFFLINE_WRITE_MESSAGE): string {
  return isBrowserOffline() ? offlineMessage : message;
}
